import React from 'react';
import QuotationCard from '../../../reusable/QuotationCard';
import { ResultModal } from './v2/ResultModal.styles';
import RiskCard from '../Cards/RiskCard';

function ModalQuotesTutela({
  type, quotations, userData, selectQuotation, addingQuote, processingQuote, index,
}) {
  return (
    <>
      <ResultModal
        className="modal fade"
        id={type.id}
        tabIndex="-1"
        aria-labelledby={type.name}
        aria-hidden="true"
        key={index}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id={type.name}>
                <h5>
                  {type.id === 'res_civile'
                    ? quotations[type.id][0]?.sub_product === 'patente_motor'
                      ? 'Tutela Legale Motor'
                      : quotations[type.id][0]?.sub_product === 'vita_privata'
                        ? 'Vita Privata'
                        : quotations[type.id][0]?.product_name
                    : type.name}
                </h5>
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="buttonClose"
              />
            </div>
            <div className="modal-body">
              {addingQuote && (
                <div className="d-flex align-items-center justify-content-between flex-column">
                  <div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">
                        Aggiungendo...
                      </span>
                    </div>
                  </div>
                  <div className="ms-2">Aggiungendo...</div>
                </div>
              )}

              {addingQuote === false && quotations[type.id]
                ? [...quotations[type.id]] // Create a copy of the array
                  .sort((a, b) => a.amount - b.amount) // Sort the copy
                  .map((quote, index) => (
                    <React.Fragment key={index}>
                      {(type.id === 'res_civile' && processingQuote !== null) && (
                        <div className="col-12 mb-2 mt-3">
                          <QuotationCard
                            requestInfo={userData}
                            quote={quote}
                            selectQuotation={selectQuotation}
                          />
                        </div>
                      )}
                      {processingQuote !== null && processingQuote.company_id === quote.company_id && type.id !== 'res_civile' ? (
                        <div className="col-12 mb-2 mt-3">
                          <RiskCard
                            type={type}
                            requestInfo={userData}
                            quote={quote}
                            selectQuotation={selectQuotation}
                          />

                        </div>
                      ) : ''}

                      {processingQuote === null && (
                        <div className="col-12 mb-2 mt-3">
                          <QuotationCard
                            requestInfo={userData}
                            quote={quote}
                            selectQuotation={selectQuotation}
                          />
                        </div>
                      )}
                    </React.Fragment>
                  ))
                : addingQuote === false && (
                  <p>
                    Nessuna Quotazione
                    {type.name}
                    {' '}
                    Trovata.
                  </p>
                )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger px-4"
                data-bs-dismiss="modal"
              >
                Chiudi
              </button>
            </div>
          </div>
        </div>
      </ResultModal>
    </>
  );
}

export default ModalQuotesTutela;
